export const INDIVIDUAL_SIGNUP_REQUEST = "individual_sign_up_request"
export const INDIVIDUAL_SIGNUP_SUCCESS = "individual_sign_up_success"
export const INDIVIDUAL_SIGNUP_FAILURE = "individual_sign_up_failure"

export const INDIVIDUAL_SIGNIN_REQUEST = "individual_signin_request"
export const INDIVIDUAL_SIGNIN_SUCCESS = "individual_signin_success"
export const INDIVIDUAL_SIGNIN_FAILURE = "individual_signin_failure"

export const CLEAR_AUTH_STATES = "clear_states"